import styled from '@emotion/styled';
import { COLORS } from '@ui-kit-ngs/theme';
import { hexToRGB } from '../../utils';
const StyledSeparator = styled.div `
  display: flex;
  flex-grow: 0;
  width: 0;
  border-left: 1px solid ${hexToRGB(COLORS.background000, 0.2)};
`;
export default StyledSeparator;
